import _ from 'lodash';
import { mapGetters } from 'vuex';
import { BILLING_CYCLE, limitBillingCycleWithBaseZoneTypes } from '@/common/constants';

export default {
  computed: {
    ...mapGetters(['getUserCurrentSubscriptions', 'limitLicenseWithCurrentBaseTypes']),
    annualAddonPlans() {
      return this.getUserCurrentSubscriptions.filter(item => (
        limitBillingCycleWithBaseZoneTypes.includes(item.type) &&
        item.billing_cycle === BILLING_CYCLE.ANNUAL
      ));
    },
    allLimitAnnualPlanNames() {
      const planGroupByType = _.groupBy(this.annualAddonPlans, 'type');
      return _.keys(planGroupByType).map(type => {
        const typeNameKey = _.get(planGroupByType[type], '0.typeNameKey', '');
        return this.$t(typeNameKey);
      }).filter(Boolean);
    },
  },
  methods: {
    getExceedCurrentBaseLicensePlans(basePlanLicenses) {
      return this.getUserCurrentSubscriptions.filter(item => (
        item.billing_cycle !== BILLING_CYCLE.ONE_TIME &&
        _.includes(this.limitLicenseWithCurrentBaseTypes, item.type) &&
        item.cartInfo.selected_number >= basePlanLicenses
      ));
    },
    getMaxAddonPlan(basePlanLicenses) {
      return _.maxBy(this.getExceedCurrentBaseLicensePlans(basePlanLicenses), (item) => {
        return item?.cartInfo?.selected_number;
      })
    },
  },
};
